export const Role = {
    user: 'MonitoringOperator',
    root: 'Root',
}

export const FullAccess = '*'
